module.exports = __webpack_public_path__ + "img/badge_chiavi_cifratura.74162467.jpg";